export default function getPreviousWorkDay(dayjsObject, disabledDates) {
  let date = dayjsObject.clone()
  if (disabledDates.includes(date.format('YYYY-MM-DD'))) {
    while (disabledDates.includes(date.format('YYYY-MM-DD'))) {
      date = date.subtract(1, 'days')
    }
  }

  return date
}
